// adapter 操作（openBluetoothAdapter / closeBluetoothAdapter）の直列化キュー。
// spjs の adapter 意味論（open 進行中の close の交差・冪等性）は未文書のため、
// JS 側で「発行順 = 完了順」を機構的に保証し、ネイティブの処理順に依存しない
// ことをこのキューが担保する（aikasa/ikasa_platform#7681 レビュー指摘の回収）:
// - pending の open がある間、close はその完了を待ってから発行される
//   （open 中断時に close が先に完了し、後着の open が開きっぱなしになる事故を防ぐ）
// - 前操作の close が完了するまで次操作の open は発行されない
//   （キャンセル直後の再試行で、古い close が新しい session を閉じる事故を防ぐ）
// 前の操作が失敗しても後続は必ず実行する（close の失敗で open が詰まらない）。
//
// 前提(#7706): キューに入る op は、op が内部で待ち合わせる Promise も含めてエンドツーエンドで
// 有界化されていること（例: closeAdapterAfter の after 引数は呼び出し側で withBridgeCap 済み
// を前提に op 内で await する）。このキュー自体は pending 耐性を持たない（settle しない op が
// 1つあると恒久停止する）ため、「op は必ず settle する」を境界の不変条件として
// 上流(SpjsStandCentral)が保証する。
//
// 【保証の範囲(#7706)】このキューが保証するのは JS 側の Promise の発行順・完了待ち順のみ。
// cap(withBridgeCap)で放棄された op の native 側実処理は取り消せず、その完了順序は SDK に
// 保証記載がない(Inforich 照会中)。放棄後の遅延完了が後続操作に作用し得る範囲と影響は
// spjsStandCentral.closeAdapterAfter のコメントおよび architecture doc の同節を参照。
export class AdapterSerializer {
  private chain: Promise<void> = Promise.resolve()

  run<T>(op: () => Promise<T>): Promise<T> {
    const result = this.chain.then(op, op)
    // チェーン自体は成否を保持しない（失敗を握って後続の実行を保証する）。
    // 呼び出し元には result をそのまま返すので、個々の操作の成否は観測できる。
    this.chain = result.then(
      () => undefined,
      () => undefined
    )
    return result
  }
}
